import React from 'react';
import { Box, Slider, Switch, useBreakpoint } from '@landr/maestro';
import { useBpmAndKeys } from '../hooks/useBpmAndKeys';
import { MaxBpm, MinBpm, useBpmFilter } from './BpmFilter';
import { BpmInputs } from './BpmInputs';

const BpmFiltersContent = () => {
    const { bpm, addBpmFilter } = useBpmAndKeys();
    const isMobile = useBreakpoint('md');

    const {
        sliderValue,
        hasRange,
        updateBpm,
        onSliderChangeEnd,
        onInputChange,
        toggleHasRange,
    } = useBpmFilter({
        value: bpm,
        onChange: addBpmFilter,
    });

    return (
        <Box width="100%">
            <Switch
                onLabel="Exact BPM"
                size={isMobile ? 'md' : 'sm'}
                isOn={!hasRange}
                onChange={toggleHasRange}
            />
            <Box paddingX="sm" marginTop="2xl" marginBottom="xl" width="100%">
                <Slider
                    key={`slider-${hasRange ? 'range' : 'single'}`}
                    min={MinBpm}
                    max={MaxBpm}
                    value={sliderValue}
                    onChange={updateBpm}
                    onChangeEnd={onSliderChangeEnd}
                />
            </Box>
            <BpmInputs
                min={MinBpm}
                max={MaxBpm}
                value={sliderValue}
                onChange={onInputChange}
                showMaxInput={hasRange}
            />
        </Box>
    );
};

export default BpmFiltersContent;
